// removed by extract-text-webpack-plugin
module.exports = {"Menu":"Type__Menu___2TV87","Additional":"Type__Additional___22EcR","Title":"Type__Title___3gs4O","Checkboxes":"Type__Checkboxes___1e8zn","Checkbox":"Type__Checkbox___1jTHE","Button":"Type__Button___9uvvx","Header":"Type__Header___UUKwy","Icon":"Type__Icon____X9TT","Active":"Type__Active___2xOFq","FirstColumn":"Type__FirstColumn___2iO8L","SecondColumn":"Type__SecondColumn___1PirA","ThirdColumn":"Type__ThirdColumn___3nA4E","ButtonWrap":"Type__ButtonWrap___23zp-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/Type/Type.scss
// module id = 1405
// module chunks = 0